module.exports = __webpack_public_path__ + "img/Facial Treatments 4.5024b319.jpg";